import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

function Paragrafo ({ title, id, text }) {
  return (
    <p
      id={id}
      style={{
        fontSize: '14px',
        marginBottom: '0px',
        display: `${text ? 'block' : 'none'}`
      }}
      title={text}
    >
      <strong>{title}: </strong>
      {text && text}
      {text && (
        <UncontrolledTooltip placement='top' target={id}>
          {text}
        </UncontrolledTooltip>
      )}
    </p>
  );
}

export default Paragrafo;



// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/Card/Paragrafo/index.js